export default __webpack_public_path__ + "static/media/dubai-studio-city.46b12613.png";